import { ExternalLinkSVG } from "@newsela/angelou";

import FormativeLogoIcon from "@/icons/FormativeLogoIcon";
import { formativeIconCss } from "@/view/FormativeGraphicOrganizerButton/FormativeGraphicOrganizerButton.style";
import {
  externalLinkSvgCss,
  linkCss,
  wrapper,
} from "./LearnMoreFormativeLink.style";

const LearnMoreFormativeLink = () => {
  return (
    <div css={wrapper}>
      <FormativeLogoIcon __cssFor={{ root: formativeIconCss }} size="SM" />
      <p>
        <a
          href="https://www.formative.com/getting-started"
          target="_blank"
          rel="noreferrer"
          css={linkCss}
        >
          Learn more about Formative
          <ExternalLinkSVG css={externalLinkSvgCss} />
        </a>
      </p>
    </div>
  );
};

export default LearnMoreFormativeLink;
